module.exports = __webpack_public_path__ + "assets/img/icon-people-blue.decc6699.png";